import { createRoot } from "react-dom/client";
import App from "./App";
import "@crema/services";
import React from "react";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
